module.exports = __webpack_public_path__ + "img/sword-earth-03.bd7390ab.png";